import Vue from 'vue'
import {permission} from './permissionUserInfo'

// 无权限禁止点击
Vue.directive('permissionClick', {
  inserted(el, binding) {
    if (permission(binding.value).headOff) {
      el.disabled = true
    }
  }
})

// 无权限隐藏
Vue.directive('permissionHide', {
  inserted(el, binding) {
    if (permission(binding.value).headOff) {
      el.style.display = 'none'
    }
  }
})